/* Offer Zone, festive version. Loaded (deferred) by snippets/offer-ladder.liquid.
   Three jobs: open/close the note on phones, open the drawer on desktop, and write the "your bag" line
   from the live cart. Everything is wrapped in try/catch and scoped to [data-ojz], [data-ojz-cap] and
   .ojzd; if anything fails the static ladder stays exactly as the server rendered it and nothing else
   on the page is affected. */
(function () {
  'use strict';
  if (window.__ojzLoaded) return;   // the script tag can appear twice (one per block); run once
  window.__ojzLoaded = true;

  function money(n) {
    try { return '₹' + Math.round(n).toLocaleString('en-IN'); }
    catch (e) { return '₹' + Math.round(n); }
  }

  // A bag of 5,798.60 must never read as 5,799 (it has not reached the tier), and "add 0.40 more" must read
  // "add 1 more", never "add 0 more". So: show what the bag HAS rounded down, what is STILL NEEDED rounded up.
  function moneyDown(n) { return money(Math.floor(n + 1e-9)); }
  function moneyUp(n) { return money(Math.ceil(n - 1e-9)); }

  /* ---- the live bag line. root holds data-tiers / data-percent / data-bag and the bag + ladder markup ---- */
  function setupBag(root) {
    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { tiers = []; }
    var percent = parseFloat(root.getAttribute('data-percent')) || 0;
    var bagBox = root.querySelector('[data-ojz-bag]');
    var nudge = root.querySelector('[data-ojz-nudge]');
    var bl = root.querySelector('[data-ojz-bl]');
    var bar = root.querySelector('[data-ojz-bar]');
    var rows = [].slice.call(root.querySelectorAll('.ojz__r'));
    if (!tiers.length || !bagBox || !nudge || root.getAttribute('data-bag') !== 'true') return function () {};

    // what the NEXT step adds on top of what the shopper already has: only the extra amount, never the percentage again
    function gain(t) { return t[1] > 0 ? 'extra ' + money(t[1]) + ' off' : percent + '% off'; }

    function have(t) { return percent + '% off' + (t[1] > 0 ? ' + extra ' + money(t[1]) + ' off' : ''); }

    var lastBag = null, seq = 0;

    function render(bag, hasExcluded) {
      var key = bag + '|' + (hasExcluded ? 1 : 0);
      if (key === lastBag && !bagBox.hidden) return;   // nothing changed: leave the screen alone
      lastBag = key;
      var reached = -1, i;
      for (i = 0; i < tiers.length; i++) { if (bag >= tiers[i][0]) reached = i; }
      var next = reached + 1 < tiers.length ? tiers[reached + 1] : null;
      rows.forEach(function (row, idx) { row.classList.toggle('is-reached', idx <= reached); });

      var lines = [], pct;
      if (bag <= 0) {
        lines.push((tiers[0][0] <= 1 ? 'Add any shirt to unlock <b>' : 'Add ' + money(tiers[0][0]) + ' to unlock <b>') + have(tiers[0]) + '</b>.');
        pct = 0;
      } else if (reached < 0) {
        lines.push('Add <b>' + moneyUp(tiers[0][0] - bag) + '</b> more to unlock <b>' + have(tiers[0]) + '</b>.');
        pct = bag / tiers[0][0] * 100;
      } else if (next) {
        lines.push('You have unlocked <b>' + have(tiers[reached]) + '</b>.');
        lines.push('Add <b>' + moneyUp(next[0] - bag) + '</b> more to get <b>' + gain(next) + '</b>.');
        pct = bag / next[0] * 100;
      } else {
        lines.push('You have unlocked the best offer: <b>' + have(tiers[reached]) + '</b>.');
        pct = 100;
      }
      var bagWord = hasExcluded ? 'Eligible bag' : 'Your bag';
      if (bl) bl.innerHTML = bag > 0 ? '<span>' + bagWord + '</span><span class="ojz__bv">' + moneyDown(bag) + '</span>' : '<span>' + (hasExcluded ? 'No eligible items yet' : 'Your bag is empty') + '</span>';
      nudge.innerHTML = lines.map(function (l) { return '<span class="ojz__ln">' + l + '</span>'; }).join('');
      if (bar) bar.style.width = Math.max(0, Math.min(100, pct)) + '%';
      bagBox.hidden = false;
    }

    return function load() {
      var mine = ++seq;
      try {
        // Only items in the offer collection count (Latest Arrivals): templates/cart.ol-elig.liquid answers with that part of the bag.
        // no Accept header on purpose: Shopify answers /cart with the cart JSON itself when asked for JSON, ignoring the view
        fetch('/cart?view=ol-elig&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function (cart) {
            if (mine !== seq) return;   // a newer answer is already on its way or on screen
            // tiers are in rupees; if the visitor is browsing in another currency, say nothing rather than be wrong
            if (!cart || (cart.currency && cart.currency !== 'INR')) { bagBox.hidden = true; return; }
            render((cart.eligible || 0) / 100, (cart.total || 0) > (cart.eligible || 0));
          })
          .catch(function () { if (mine === seq) bagBox.hidden = true; });
      } catch (e) { bagBox.hidden = true; }
    };
  }

  var refreshers = [];   // every live bag line on the page
  function refreshAll() { refreshers.forEach(function (fn) { fn(); }); }

  /* ---- J: the note (phones) ---- */
  function initNote(root) {
    if (root.getAttribute('data-ojz-ready') === '1') return;
    root.setAttribute('data-ojz-ready', '1');
    var toggle = root.querySelector('[data-ojz-toggle]');
    var label = root.querySelector('[data-ojz-label]');
    var load = setupBag(root);
    refreshers.push(load);
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) load();
        if (label) {
          label.textContent = open
            ? (root.getAttribute('data-label-open') || label.textContent)
            : (root.getAttribute('data-label-closed') || label.textContent);
        }
      });
    }
    load();
  }

  /* ---- F: the caption and its drawer (desktop) ---- */
  function initCaption(cap) {
    if (cap.getAttribute('data-ojz-ready') === '1') return;
    cap.setAttribute('data-ojz-ready', '1');

    var owner = cap.getAttribute('data-owner');
    var old = owner && document.querySelector('.ojzd[data-owner="' + owner + '"]');   // theme editor re-render
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var tpl = cap.querySelector('[data-ojz-drawer-tpl]');
    var opener = cap.querySelector('[data-ojz-open]');
    if (!tpl || !opener) return;

    var drawer = null, load = function () {}, lastFocus = null;

    function build() {
      var frag = tpl.content.cloneNode(true);
      drawer = frag.firstElementChild;
      if (owner) drawer.setAttribute('data-owner', owner);
      document.body.appendChild(drawer);
      load = setupBag(drawer);
      refreshers.push(load);
      [].forEach.call(drawer.querySelectorAll('[data-ojz-close]'), function (b) { b.addEventListener('click', close); });
      drawer.addEventListener('keydown', trap);
      // Keep the page behind from scrolling WITHOUT hiding the page scrollbar (hiding it makes the whole
      // page jump sideways by the scrollbar's width). The overlay swallows wheel and touch scrolling,
      // and the panel never hands its own scrolling on to the page.
      var ov = drawer.querySelector('.ojzd__ov');
      var panel = drawer.querySelector('.ojzd__p');
      function stop(e) { e.preventDefault(); }
      if (ov) { ov.addEventListener('wheel', stop, { passive: false }); ov.addEventListener('touchmove', stop, { passive: false }); }
      if (panel) {
        panel.addEventListener('wheel', function (e) { if (panel.scrollHeight <= panel.clientHeight) e.preventDefault(); }, { passive: false });
      }
    }

    function trap(e) {
      if (e.key !== 'Tab' || !drawer) return;
      var f = [].slice.call(drawer.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    function open() {
      if (!drawer) build();
      lastFocus = document.activeElement;
      load();
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var x = drawer.querySelector('.ojzd__x');
        if (x) x.focus();
      });
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    opener.addEventListener('click', open);
  }

  ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, refreshAll); });
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAll);
    }
  } catch (e) { /* Dawn pub/sub not present: the events above still cover the theme's own cart:refresh */ }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshAll(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshAll(); });
  window.addEventListener('focus', refreshAll);
  // The cart can change without the theme announcing it (an app, a quick-add, another tab).
  // While the offer is actually open on screen and the tab is visible, look again every 2.5 seconds.
  setInterval(function () {
    if (document.hidden) return;
    if (document.querySelector('.ojz.is-open, .ojzd.is-open')) refreshAll();
  }, 2500);

  function boot() {
    try { [].forEach.call(document.querySelectorAll('[data-ojz]'), initNote); } catch (e) { /* leave the static note */ }
    try { [].forEach.call(document.querySelectorAll('[data-ojz-cap]'), initCaption); } catch (e) { /* leave the static caption */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
